import { memo } from 'react'
import { Skeleton } from '../../../shared/ui/Skeleton'

export const SourceRowSkeleton = memo(function SourceRowSkeleton({
  isLargeScreen,
}: {
  isLargeScreen: boolean
}) {
  return (
    <div
      className="source-grid-item"
      style={{
        display: 'grid',
        gridTemplateColumns: isLargeScreen
          ? 'minmax(200px, 3fr) 180px 180px 120px'
          : '1fr 120px',
        padding: '20px 24px',
        alignItems: 'center',
        borderBottom: '1px solid var(--divider)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <Skeleton className="h-10 w-10 rounded-[10px]" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>

      {isLargeScreen && (
        <>
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-20" />
        </>
      )}

      <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
        <Skeleton className="h-9 w-9 rounded-lg" />
        <Skeleton className="h-9 w-9 rounded-lg" />
        <Skeleton className="h-9 w-9 rounded-lg" />
      </div>
    </div>
  )
})

export const SourceDetailSkeleton = memo(function SourceDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between">
        <Skeleton className="h-7 w-32" />
        <Skeleton className="h-9 w-20" />
      </div>
      <div className="grid grid-cols-[auto,1fr] gap-x-8 gap-y-4">
        {[...Array(7)].map((_, i) => (
          <React.Fragment key={i}>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-48" />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
})

import React from 'react'
